import { FilterType } from "@containers/TicketFilter";

export const filterToString = (filter: FilterType[]) =>
  filter
    .map(({ label, operation, field }) => `${field} ${operation} ${label}`)
    .join(" | ");
